/* unplugin-vue-components disabled */import { render } from "./MoreInfoItem.vue?vue&type=template&id=3349027c&scoped=true&ts=true"
import script from "./MoreInfoItem.vue?vue&type=script&lang=ts"
export * from "./MoreInfoItem.vue?vue&type=script&lang=ts"

import "./MoreInfoItem.vue?vue&type=style&index=0&id=3349027c&lang=scss&scoped=true"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3349027c"]])

export default __exports__